import type { Brief } from '../../logic/brief';
import { empty, section } from '../../ui/components';
import { h } from '../../ui/dom';
import { followUpRouteButton } from '../followUpRouteButton';
import { briefRow } from './briefRow';

export const dueGroups = (brief: Brief): HTMLElement => {
  const overdue = brief.followUps.filter(x => (x.daysOverdue ?? 0) > 0);
  const today = brief.followUps.filter(x => x.daysOverdue === 0);
  const routed = brief.stops.filter(x => x.daysOverdue !== undefined).length;
  const total = brief.followUps.length + routed;
  return h('div', {},
    total ? followUpRouteButton(total) : null,
    routed ? h('p', { class: 'muted small' }, `${routed} already on route — actions below in Walk-in route.`) : null,
    section({ title: 'Overdue', count: overdue.length, tone: 'danger' },
      overdue.length ? overdue.map(x => briefRow(x)) : empty('Nothing overdue.')),
    section({ title: 'Due today', count: today.length, tone: 'warn' },
      today.length ? today.map(x => briefRow(x)) : empty('Nothing else due today.')),
  );
};
